module.exports = __webpack_public_path__ + "img/mind_background_2_th.9c0df92e.png";